import { render, staticRenderFns } from "./ConstructionUserCard.vue?vue&type=template&id=6625dbef&scoped=true&lang=pug&"
import script from "./ConstructionUserCard.vue?vue&type=script&lang=ts&"
export * from "./ConstructionUserCard.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionUserCard.vue?vue&type=style&index=0&id=6625dbef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625dbef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
